/* eslint-disable no-console */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { client as supabaseClient } from "../utils/supabase";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyMagicLink = async () => {
      const hash = window.location.hash.substring(1); // Parse #type=magiclink&token_hash=...
      const params = new URLSearchParams(hash);
      const type = params.get("type");
      const token_hash = params.get("token_hash");

      if (type === "magiclink" && token_hash) {
        console.log("Verifying magic link...");
        const { data, error } = await supabaseClient.auth.verifyOtp({
          type: "magiclink",
          token_hash,
        });
        if (error) {
          console.error("Verify OTP error:", error);
          navigate("/login"); // Redirect si falla
        } else {
          console.log("Session set from callback:", data.session);
          navigate("/admin"); // Redirect a admin post-éxito
        }
      } else {
        navigate("/login");
      }
    };
    verifyMagicLink();
  }, [navigate]);

  return <div>Cargando...</div>; // Loader mientras
};

export default AuthCallback;
